import {
  defineComponent,
  reactive,
  watch,
  getCurrentInstance
} from '@vue/composition-api'
import RichUtil from '@/pages/Survey/components/RichUtil/index.vue'
import { getTopicOptions, changeOptionValue } from '../../util'
import _ from 'lodash'
import { useRequest } from '@/utils/bhooks'
import { isDeleteOption } from '@/services/survey'
import { getParamsValue, tran } from '@/utils/assist'
import { minusItemClick } from '../../topicCommonUtil'
import { Message } from '@gcommon/gcommon-ui'
import CommonTetxEdit from '@/components/CommonTetxEdit'
import moment from 'moment'
import OptionSettings from '../../../SurveyDetail/compontents/optionSettings'
const SelectEdit = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, context) {
    const { emit } = context
    const state = reactive({
      editItem: _.cloneDeep(props.item) //编辑数据源
    })
    const changeOptionsRewrite = (value, options, isChild = 0) => {
      changeOptionValue(value, options, isChild)
    }
    const vm = getCurrentInstance()
    //i18n 国际化
    const tran = function (initParam) {
      return vm?.proxy.$t(initParam) as string
    }
    watch(
      () => state.editItem,
      (val) => {
        emit('changeTopicContent', val)
      },
      {
        deep: true
      }
    )

    const { state: isDeleteData, run: isDeleteOptionFn } =
      useRequest(isDeleteOption)
    const minusItemClickFn = async (index, state) => {
      await minusItemClick(index, state, isDeleteOptionFn)
    }

    const changeRandomOrder = (value) => {
      state.editItem.topicSetting.isRandomOrder = value
      //当value为false时，需要把表格固定选项位置选项置空
      if (!value) {
        state.editItem.topicSetting.topicOptionSetting =
          state.editItem.topicSetting.topicOptionSetting.map((item) => {
            return Object.assign({}, item, { isFixedNo: false })
          })
      }
    }

    const optionSettingItem = reactive({
      item: state.editItem.topicSetting.topicOptionSetting?.[0],
      index: 0
    })

    const addMatrixSubtopics = (index) => {
      const option = {
        //选项设置
        optionName: '', //选项name
        optionId: '', //选项ID
        isAddText: false, //是否允许填空
        isRequire: false, //是否必填
        isEncryption: false,
        format: '', //填空格式，枚举示例（number：数字、letter：字母、chinese：中文、email：Email、phone：手机号码）
        isFixedNo: false, //是否固定选项
        optionOrder: index + 1,
        key: new Date().getTime()
      }
      state.editItem.topicSetting.topicOptionSetting.splice(
        index + 1,
        0,
        option
      )
      // 给选项的order重新赋值
      state.editItem.topicSetting.topicOptionSetting.map((i, index) => {
        i.optionOrder = index + 1
      })
    }

    const deleteMatrixSubtopics = (index) => {
      if (state.editItem.topicSetting.topicOptionSetting.length < 3) {
        Message({
          message: tran('survy.choiceTips'),
          type: 'warning'
        })
      } else {
        state.editItem.topicSetting.topicOptionSetting.splice(index, 1)
      }
    }

    return () => {
      //题目选项
      return (
        <div class="topic-edit-content">
          <div class="topic-edit-content-item topic-edit-content-title">
            {/* <div class="topic-edit-content-item-title">{tran('survy.seleName')}:</div>
            <RichUtil
              onchangeValue={(value) => (state.editItem.topicName = value)}
              placeholder={tran('survy.plctopicname')}
              value={state.editItem.topicName}></RichUtil> */}
            {/* {!props.item.isAddStatus && (
              <div class="topic-edit-content-title-order">
                {!props.item.topicSetting.isAllowNull && <i>*</i>}
                {props.item.order}.
              </div>
            )}
            <el-input
              type="textarea"
              class="rich-input"
              autosize={true}
              resize="none"
              // size='small'
              placeholder="请输入下拉题目名"
              value={state.editItem.topicName}
              onInput={(value) =>
                (state.editItem.topicName = value)
              }></el-input> */}
            {!state.editItem.isAddStatus && (
              <div class="topic-edit-content-title-order">
                {!state.editItem.topicSetting.isAllowNull && <i>*</i>}
                {state.editItem.order}.
              </div>
            )}
            <div style={{ width: '100%' }}>
              <CommonTetxEdit
                needDynamicEvent
                initialData={state.editItem.topicName}
                placeholder={tran('survy.seleName')}
                handleUpdate={(value) => {
                  state.editItem.topicName = value
                }}
              />
            </div>
          </div>
          <div class="topic-edit-content-item">
            {/* <div class="topic-edit-content-item-title">{tran('survy.seleRemark')}:</div>
            <RichUtil
              onchangeValue={(value) =>
                (state.editItem.topicSetting.topicRemark = value)
              }
              placeholder={tran('survy.plcremark')}
              value={state.editItem.topicSetting.topicRemark}></RichUtil> */}
            {/* <el-input
              type="textarea"
              class="rich-input"
              autosize={true}
              resize="none"
              size="small"
              placeholder="请输入题目备注"
              value={state.editItem.topicSetting.topicRemark}
              onInput={(value) =>
                (state.editItem.topicSetting.topicRemark = value)
              }></el-input> */}
            <CommonTetxEdit
              needDynamicEvent
              initialData={state.editItem.topicSetting.topicRemark}
              placeholder={tran('survy.plcremark')}
              handleUpdate={(value) => {
                state.editItem.topicSetting.topicRemark = value
              }}
            />
          </div>
          {/* <div class="topic-edit-content-item"> */}
          {/* <el-checkbox
              value={state.editItem.topicSetting.isAllowNull}
              onInput={(value) =>
                (state.editItem.topicSetting.isAllowNull = value)
              }>
              {tran('survy.noneedans')}
            </el-checkbox>
            <el-checkbox
              value={state.editItem.topicSetting.isRandomOrder}
              onInput={(value) => changeRandomOrder(value)}>
              {tran('survy.freeone')}
            </el-checkbox> */}
          {/* </div> */}
          <div class="topic-edit-content-item">
            {/* <div class="topic-edit-content-item-table-header">
              <div style={{ flex: '3' }}>{tran('survy.chosecontent')}</div>
              <div style={{ flex: '2' }}>{tran('survy.fix')}</div>
              <div style={{ flex: '1' }}>{tran('survy.option')}</div>
            </div>
            <div class="topic-edit-content-item-table-body">
              {state.editItem.topicSetting.topicOptionSetting.map(
                (item, index) => {
                  return (
                    <div class="topic-edit-content-item-table-body-item">
                      <div style={{ flex: '3' }}>
                        <el-input
                          size="small"
                          onInput={(value) => (item.optionName = value)}
                          value={item.optionName}
                          placeholder={tran('survy.plccontent')}></el-input>
                      </div>
                      <div style={{ flex: '2' }}>
                        <el-checkbox
                          disabled={!state.editItem.topicSetting.isRandomOrder}
                          value={item.isFixedNo}
                          onInput={(value) =>
                            (item.isFixedNo = value)
                          }></el-checkbox>
                      </div>
                      <div class="topic-edit-content-item-table-body-item-plus" style={{ flex: '1' }}>
                        <i
                          onClick={() => addItemClick(index)}
                          class="el-icon-circle-plus-outline"></i>
                        {state.editItem.topicSetting.topicOptionSetting.length >
                          2 && (
                            <i
                              onClick={() => minusItemClickFn(index, state)}
                              class="el-icon-remove-outline"></i>
                          )}
                      </div>
                    </div>
                  )
                }
              )}
            </div> */}
            <el-select
              size="medium"
              style={{ width: '400px' }}
              disabled
              placeholder={tran('survy.plcselect')}
              value={{}}>
              <el-option label="" value=""></el-option>
            </el-select>
            {state.editItem.topicSetting.topicOptionSetting.map(
              (sitem, index) => {
                return (
                  <div
                    class="option-radio"
                    key={`${sitem.optionId ? sitem.optionId : sitem.key}`}>
                    {/* <el-input
                      style={{ width: '400px' }}
                      onfocus={() => {
                        optionSettingItem.item = sitem
                        optionSettingItem.index = index
                      }}
                      onInput={(value) => {
                        sitem.optionName = value
                        // state.editItem.topicSetting.topicOptionSetting =
                        //   props.item.topicSetting.topicOptionSetting
                      }}
                      value={sitem.optionName}
                      class="option-radio-input rich-input"
                      size="small"
                      placeholder="请输入选项"></el-input> */}
                    <CommonTetxEdit
                      style={{ width: '400px' }}
                      initialData={sitem.optionName}
                      placeholder={tran('survy.optionName')}
                      formFocus={() => {
                        optionSettingItem.item = sitem
                        optionSettingItem.index = index
                      }}
                      handleUpdate={(value, index) => {
                        sitem.optionName = value
                      }}
                    />
                    <i
                      class="el-icon-circle-plus-outline el-icon-common-class"
                      onClick={() => {
                        addMatrixSubtopics(index)
                      }}></i>
                    <i
                      class="el-icon-delete el-icon-common-class"
                      onClick={() => {
                        deleteMatrixSubtopics(index)
                      }}></i>
                  </div>
                )
              }
            )}
          </div>
          <div class="topic-edit-content-item">
            {/* <div class="topic-edit-content-item-title">{tran('survy.seleend')}:</div>
            <RichUtil
              needDynamicEvent={false}
              onchangeValue={(value) =>
                (state.editItem.topicSetting.endword = value)
              }
              placeholder={tran('survy.earlyend')}
              value={state.editItem.topicSetting.endword}></RichUtil> */}
            {/* <el-input
              type="textarea"
              class="rich-input"
              autosize={true}
              resize="none"
              size="small"
              placeholder="下拉题提前结束语"
              value={state.editItem.topicSetting.endword}
              onInput={(value) =>
                (state.editItem.topicSetting.endword = value)
              }></el-input> */}
            <CommonTetxEdit
              needDynamicEvent={true}
              initialData={state.editItem.topicSetting.endword}
              placeholder={tran('survy.seleend')}
              handleUpdate={(value) => {
                state.editItem.topicSetting.endword = value
              }}
            />
          </div>
          <Portal to="survey-option-settings">
            <OptionSettings
              type={props.item.topicType}
              isAllowNull={state.editItem.topicSetting.isAllowNull}
              isRandomOrder={state.editItem.topicSetting.isRandomOrder}
              optionSettingItem={optionSettingItem}
              onChangeOptionSettingItem={(value) => {
                state.editItem.topicSetting.topicOptionSetting.splice(
                  value.index,
                  1,
                  value.item
                )
              }}
              onChangeIsAllowNull={(value) => {
                state.editItem.topicSetting.isAllowNull = value
              }}
              onChangeIsRandomOrder={(value) => changeRandomOrder(value)}
            />
          </Portal>
        </div>
      )
    }
  }
})
export default SelectEdit
